import React from 'react';
import { syncBlogs, syncBlog, syncBlogMetafields, saveBlogs, createBlogCustomContents, deleteBlogCustomContent, exportBlogs, importBlogs, clearExportUrls, resetErrors } from '../../modules/blogs'
import withRouter from 'with-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import ItemsList from '../../components/ItemsList'
import ItemsListSkeleton from '../../components/ItemsListSkeleton'
import LoadingIndicator from '../../components/LoadingIndicator';
import EmptyView from '../../components/EmptyView';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import OptionsMenu from '../../components/OptionsMenu';
import NewFlexItemList from '../../components/NewFlexItemList';
import cloneDeep from 'lodash/cloneDeep';
import Link from '@mui/material/Link';
import { Trans, withTranslation, useTranslation } from 'react-i18next';
import ExportImportDialogs from '../../components/ExportImportDialogs';
import { _clearUnchangedFields } from '../../helper';
import API from '../../api/api';


class Blogs extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      data: [],
      addingNewCustomContent: false,
      addingNewCustomContentBlogId: null,
      customContentPlainTextData: [],
      showDownloadDialog: true,
      showImportCompleteDialog: false,
      errorLockCollapse: false,
      forceOpenExportDialog: false,
      forceOpenImportDialog: false,
    }
  }

  componentDidMount() {
    this.props.syncBlogs(this.props.editLanguage)

    if(this.props.blogs.export_po_download_url || this.props.blogs.export_csv_download_url) {
      this.setState({showDownloadDialog: false})
    }
  }

  componentWillUnmount() {
    API.clearAllFetches();
  }

  getErrorsFor(key, item) {
    if (typeof item.errors === 'undefined') return false;
    let error = item.errors.find(x => x.object_key === key);
    return error;
  }

  componentWillReceiveProps(newProps) {
    const { t } = this.props;
    const currentLanguage = this.props.editLanguage;
    const newLanguage = newProps.editLanguage;
    if(currentLanguage != newLanguage) {
      this.props.syncBlogs(newLanguage)
      return
    }

    if(this.props.blogs.import_blogs_pending === true && newProps.blogs.import_blogs_pending === false && !newProps.blogs.error && !newProps.blogs.import_cancelled) {
      this.setState({showImportCompleteDialog: true}, () => {
        this.setState({showImportCompleteDialog: false});
      })
    }

    if((this.props.blogs.sync_blog_pending === true && newProps.blogs.sync_blog_pending === false) || (this.props.blogs.save_blogs_pending === true && newProps.blogs.save_blogs_pending === false) || (this.props.blogs.sync_blogs_pending === true && newProps.blogs.sync_blogs_pending === false)) {
      const newData = [];
      newProps.blogs.blogs.forEach(item => {
        let customFields = []

        if(item.custom_contents) {
          item.custom_contents.forEach(custom_content => {
            customFields.push({
              id: custom_content.id,
              type: 'text',
              deletable: true,
              multiline: true,
              rows: 7,
              source: custom_content.source.text,
              target: custom_content.target.text
            })
          })
        }

        let currentMetafields = null;
        if(!(this.props.blogs.sync_blogs_pending === true && newProps.blogs.sync_blogs_pending === false)) {
          const currentBlog = this.state.data.find(x => x.id == item.id);
          if(currentBlog) {
            currentMetafields = currentBlog.fields.find(x => x.id === 'metafields');
          }
        }

        let seoFields = []

        if(typeof item.target.page_title !== 'undefined') {
          seoFields.push({
            id: 'page_title',
            type: 'text',
            label: 'SEO Title',
            source: item.source.page_title || '',
            target: item.target.page_title || '',
            customized: item.customSeo.meta_title,
            maxLength: 255,
          })
        }
        if(typeof item.target.page_description !== 'undefined') {
          seoFields.push({
            multiline: true,
            rows: 6,
            id: 'page_description',
            type: 'text',
            label: 'SEO Description',
            source: item.source.page_description || '',
            target: item.target.page_description || '',
            customized: item.customSeo.meta_description,
            maxLength: 500,
          })
        }

        newData.push({
          type: 'blog',
          id: item.id,
          progress: item.progress,
          synchronized: item.synchronized,
          metafields_synchronized: item.metafields_synchronized,
          title: item.source.title,
          info: '',
          fields: [{
            id: 'title',
            type: 'text',
            label: 'Title',
            source: item.source.title,
            target: item.target.title || ''
          },
          {
            id: 'handle',
            type: 'text',
            label: 'Handle',
            source: item.source.handle,
            target: item.target.handle || '',
            errors: this.getErrorsFor('handle', item) || false
          },
          {
            id: 'seofields',
            type: 'subfields',
            fields: seoFields
          },
          {
            id: 'metafields',
            type: 'subfields',
            fields: currentMetafields ? cloneDeep(currentMetafields.fields) : []
          },
          {
            id: 'customfields',
            onAddItem: this.openNewCustomContentDialog,
            onDeleteItem: this.onDeleteCustomContent(item.id),
            emptyMessage: <EmptyView 
              title={t('customContents.noCustomContentInSection')}
              description={t('customContents.info1')}
              bottom={<Button variant="outlined" size="small" onClick={e => {this.openNewCustomContentDialog(item.id)}}>{t('customContents.addNewCustomContent')}</Button>}
              dense={true} 
            />,
            type: 'subfields',
            fields: customFields
          }]
        })
      })
      
      this.setState({data:newData});
    }

    if(this.props.blogs.sync_blog_metafields_pending === true && newProps.blogs.sync_blog_metafields_pending === false) {
      let newData = cloneDeep(this.state.data);
      newProps.blogs.blogs.forEach(blog => {
        if(blog.metafields) {
            let blogToUpdate = newData.find(x => x.id == blog.id)

            let newMetafields = []
            blog.metafields.forEach(metafield => {
              const currentField = blogToUpdate.fields.find(x => x.id === 'metafields').fields.find(x => x.id == metafield.id);
              if(!currentField) {
                newMetafields.push({
                  id: metafield.id,
                  type: 'text',
                  multiline: true,
                  rows: 7,
                  source: metafield.source,
                  target: metafield.target || '',
                  label: metafield.namespace + ' -> ' + metafield.key
                })
              } else {
                if(blog.metafields.find(x => x.id === currentField.id)) {
                  newMetafields.push({...currentField});
                }
              }
            })

            blogToUpdate.metafields_synchronized = blog.metafields_synchronized
            blogToUpdate.fields.find(x => x.id === 'metafields').fields = newMetafields
        }
      })

      this.setState({data:newData});
    }

    if((this.props.blogs.create_blog_custom_contents_pending === true && newProps.blogs.create_blog_custom_contents_pending === false) || (this.props.blogs.delete_blog_custom_content_pending === true && newProps.blogs.delete_blog_custom_content_pending === false)) {
      let newData = cloneDeep(this.state.data);
      newProps.blogs.blogs.forEach(blog => {
        if(blog.custom_contents) {
            let blogToUpdate = newData.find(x => x.id == blog.id)

            let newCustomContents = []
            blog.custom_contents.forEach(custom_content => {
              const currentField = blogToUpdate.fields.find(x => x.id === 'customfields').fields.find(x => x.id == custom_content.id);
              if(!currentField) {
                newCustomContents.push({
                  id: custom_content.id,
                  type: 'text',
                  deletable: true,
                  multiline: true,
                  rows: 7,
                  source: custom_content.source.text,
                  target: custom_content.target.text
                })
              } else {
                if(blog.custom_contents.find(x => x.id === currentField.id)) {
                  newCustomContents.push({...currentField});
                }
              }
            })

            blogToUpdate.custom_contents_synchronized = blog.custom_contents_synchronized
            blogToUpdate.fields.find(x => x.id === 'customfields').fields = newCustomContents
        }
      })

      this.setState({data:newData});
    }
  }


  onExpand(id) {
    if(this.state.data.find(x => x.id == id).synchronized !== true) {
      this.props.syncBlog(id, this.props.editLanguage);
    }
  }

  onCollapsed(id) {
    
  }

  onExpandCollapsableFields = (type, id) => {
    if(type === 'metafields' && this.state.data.find(x => x.id == id).metafields_synchronized != true) {
      this.props.syncBlogMetafields(id, this.props.editLanguage)
    }
  }

  onSave = items => {
    const usedItems = [];
    items.forEach(item => {
      usedItems.push({
        id: item.id,
        title: item.fields.find(x => x.id === 'title').target,
        handle: item.fields.find(x => x.id === 'handle').source == item.fields.find(x => x.id === 'handle').target ? '' : item.fields.find(x => x.id === 'handle').target,
        page_title: item.fields.find(x => x.id === 'seofields').fields.find(x => x.id === 'page_title').target,
        page_description: item.fields.find(x => x.id === 'seofields').fields.find(x => x.id === 'page_description').target,
        metafields: item.fields.filter(x => (x.type === 'subfields' && x.id === 'metafields'))[0].fields.map(z => ({ id: z.id, target: z.target })),
        custom_contents: item.fields.filter(x => (x.type === 'subfields' && x.id === 'customfields'))[0].fields.map(z => ({ id: z.id, target: z.target })),
      });
    })

    this.props.saveBlogs(this.props.editLanguage, usedItems)
  }

  onResaveAll = (itemId) => {
    const item = this.state.data.find(x => x.id == itemId);
    if(item) {
      const usedItems = [{
        id: item.id,
        title: item.fields.find(x => x.id === 'title').target,
        page_title: item.fields.find(x => x.id === 'seofields').fields.find(x => x.id === 'page_title').target,
        page_description: item.fields.find(x => x.id === 'seofields').fields.find(x => x.id === 'page_description').target,
        metafields: item.fields.filter(x => (x.type === 'subfields' && x.id === 'metafields'))[0].fields.map(z => ({ id: z.id, target: z.target })),
        custom_contents: item.fields.filter(x => (x.type === 'subfields' && x.id === 'customfields'))[0].fields.map(z => ({ id: z.id, target: z.target })),
      }]

      this.props.saveBlogs(this.props.editLanguage, usedItems, 1)
    }
  }

  openNewCustomContentDialog = (itemId) => {
    const customContentPlainTextData = [];
    const blog = this.state.data.find(x => x.id == itemId);

    blog.fields.find(x => x.id == 'customfields').fields.forEach((custom_content) => {
      customContentPlainTextData.push(custom_content.source);
    })

    this.setState({addingNewCustomContent: true, addingNewCustomContentBlogId: itemId, customContentPlainTextData: customContentPlainTextData})
  }

  closeNewCustomContentDialog = ()  => {
    this.setState({addingNewCustomContent: false, addingNewCustomContentBlogId: null, customContentPlainTextData: []})
  }

  onSaveNewCustomContentDialog = (blogId, items) => {
    const usedItems = [];
    items.forEach(item => {
      if(item.text != '') {
        usedItems.push({
          text: item.text
        })
      }
    })
    
    this.setState({addingNewCustomContent: false, addingNewCustomContentBlogId: null});
    this.props.createBlogCustomContents(blogId, this.props.editLanguage, usedItems);
  }

  onDeleteCustomContent = blogId => {
    return itemId => {
      this.props.deleteBlogCustomContent(blogId, itemId);
    }
  }

  onImport = (e) => {
    this.setState({forceOpenImportDialog: true}, () => {
      this.setState({forceOpenImportDialog: false});
    });   
    this.setState({ optionsMenuAnchorEl: null });
  }

  onExport = (e) => {
    this.setState({forceOpenExportDialog: true}, () => {
      this.setState({forceOpenExportDialog: false});
    });   
  }

  onCloseDownloadDialog = () => {
    this.setState({showDownloadDialog: false})
  }

  onCloseImportCompleteDialog = () => {
    window.location.reload();
  }

  render() {
    const { t, classes } = this.props

    if(this.props.blogs.sync_blogs_pending === true || (this.props.blogs.error && this.props.blogs.error.level === 0)) {
      return <React.Fragment>
        <Typography variant="h4" gutterBottom component="h2">
          {t('pages.blogs.title')}
        </Typography>
        <Divider className="divider-white" />
        <ItemsListSkeleton rows="10"/>
        <LoadingIndicator
          pending={this.props.blogs.sync_blogs_pending || this.props.blogs.sync_blog_pending || this.props.blogs.save_blogs_pending || this.props.blogs.export_blogs_pending}
          progress={this.props.blogs.progress}
          error={this.props.blogs.error}
        />
      </React.Fragment>  
    }

    return <React.Fragment>
      <Typography variant="h4" gutterBottom component="h2">
        {t('pages.blogs.title')}

        <OptionsMenu
          onImport={this.onImport}
          onExport={this.onExport}
          shopPlan={this.props.shopPlan}
        />
      </Typography>

      {this.state.addingNewCustomContent ? (
        <NewFlexItemList
          scope={this.state.addingNewCustomContentBlogId}
          data={this.state.customContentPlainTextData}
          onSave={this.onSaveNewCustomContentDialog}
          onCancel={this.closeNewCustomContentDialog}
          isPending={false}
        />
      ) : (
        null
      )}

      <Divider className="divider-white" />

      <ItemsList 
        type="blogs"
        pagination={true}
        onExpand={(id) => {this.onExpand(id)}}
        onCollapsed={this.onCollapsed}
        isPending={
          this.props.blogs.sync_blogs_pending ||
          this.props.blogs.sync_blog_pending ||
          this.props.blogs.sync_blog_metafields_pending ||
          this.props.blogs.create_blog_custom_contents_pending ||
          this.props.blogs.delete_blog_custom_content_pending ||
          this.props.blogs.save_blogs_pending ||
          this.props.blogs.export_blogs_pending ||
          this.props.blogs.import_blogs_pending
        }
        isSubfieldsPending={
          this.props.blogs.create_blog_custom_contents_pending ||
          this.props.blogs.delete_blog_custom_content_pending ||
          this.props.blogs.sync_blog_metafields_pending
        }
        isSaving={
          this.props.blogs.save_blogs_pending
        }
        onSave={this.onSave}
        onResaveAll={this.onResaveAll}
        data={this.state.data}
        onExpandCollapsableFields={this.onExpandCollapsableFields}
        allowAutoTranslation={true}
        error={this.props.blogs.error}
        errorLockCollapse={this.state.errorLockCollapse}
        emptyMessage={
          <EmptyView 
            title={t('pages.blogs.noContent')}
            bottom={<Button href={`https://${this.props.shopUrl}/admin/articles`} target="_blank" variant="contained" color="primary">{t('system.createOneHere')}</Button>}
          />
        }
      />
      <LoadingIndicator
        pending={this.props.blogs.sync_blogs_pending || this.props.blogs.sync_blog_pending || this.props.blogs.import_blogs_pending || this.props.blogs.sync_blog_metafields_pending || this.props.blogs.save_blogs_pending || this.props.blogs.create_blog_custom_contents_pending || this.props.blogs.delete_blog_custom_content_pending || this.props.blogs.export_blogs_pending}
        loadingType={this.props.blogs.save_blogs_pending ? 'saving' : 'loading'}
        progress={this.props.blogs.progress}
        error={this.props.blogs.error}
        onErrorCancel={this.props.resetErrors}
        onErrorRetry={() => {
          this.setState({ errorLockCollapse: true }, () => {
            this.setState({ errorLockCollapse: false });
          });
        }}
      />

      <ExportImportDialogs
        //showDownloadDialog={this.state.showDownloadDialog}
        showImportCompleteDialog={this.state.showImportCompleteDialog}
        imported_entries={this.props.blogs.imported_entries}
        export_po_download_url={this.props.blogs.export_po_download_url}
        export_csv_download_url={this.props.blogs.export_csv_download_url}
        forceOpenExportDialog={this.state.forceOpenExportDialog}
        forceOpenImportDialog={this.state.forceOpenImportDialog}
        exportFunc={(options) => { this.props.exportBlogs(this.props.editLanguage, options) }}
        importFunc={(formData, fileType, options) => { this.props.importBlogs(formData, fileType, this.props.editLanguage, options) }}
        syncFunc={() => { this.props.syncBlogs(this.props.editLanguage)}}
        clearFunc={this.props.clearExportUrls}
        pending={this.props.blogs.export_blogs_pending}
        scope={'blogs'}
        additionalFields={['custom_contents','with_BOM']}
      />
    </React.Fragment> 
  }
}

const mapStateToProps = ({ blogs, shop }) => ({
  blogs: blogs,
  editLanguage: shop.shop.edit_language,
  shopPlan: shop.shop.charge.name,
  shopUrl: shop.shop.url,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      syncBlogs,
      syncBlog,
      syncBlogMetafields,
      createBlogCustomContents,
      deleteBlogCustomContent,
      saveBlogs,
      exportBlogs,
      importBlogs,
      resetErrors,
      clearExportUrls
    },
    dispatch
  )

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Blogs)))